import React, { useEffect, useState } from "react";
import styles from "./StoreFront.module.scss";
import StoreTabSelector from "./layout/StoreTabSelector";
import ShopByLayout from "./components/shop-by-layout/ShopByLayout";
import ProductItem from "./components/product-item/ProductItem";
import NewDeals from "./components/new-deals/NewDeals";
import { toast } from "react-toastify";
import CategoryItem from "./components/category-item/CategoryItem";
import { CategoryWithProduct } from "../../model/solar-product/category-with-product";
import { BounceLoader } from "react-spinners";
import StoreBanner from "./components/store-banner/StoreBanner";
import { SolarProductObject } from "../../model/solar-product/solar-product-with-recommendations";
import { useGetProductCategoriesQuery } from "../../service/category-service";
import { useGetProductsByCategoriesQuery } from "../../service/solar-product-service";

type Props = {};

const StoreFront: React.FC<Props> = (props: Props) => {
	const { data: categoriesData, isLoading: isCategoriesLoading, error: categoriesError } = useGetProductCategoriesQuery();
	const {
		data: productsByCategoriesData,
		isLoading: isProductsLoading,
		error: productsError
	  } = useGetProductsByCategoriesQuery();
	const [productsByCategories, setProductsByCategories] = useState<CategoryWithProduct[]>([]);

    useEffect(() => {
		if (categoriesError) {
		  toast.error("Something went wrong while fetching Categories");
		}
	  }, [categoriesError]);

	  useEffect(() => {
		if (productsError) {
		  toast.error("Something went wrong while fetching Products in Categories");
		}
	}, [productsError]);

	useEffect(() => {
		if (productsByCategoriesData) {
			setProductsByCategories(productsByCategoriesData || []);
		}
	}, [productsByCategoriesData]);

	const updateProductWishlistStatus = (product: SolarProductObject, productId: string, isInWishlist: boolean) => {
		if (product?.solarProduct?.id === productId) {
			return {
				...product,
				solarProduct: { ...product.solarProduct, isWishlisted: isInWishlist },
			};
		}
		return product;
	};
	
	const updateCategoryProducts = (categoryWithProduct: CategoryWithProduct, productId: string, isInWishlist: boolean) => {
		return {
			...categoryWithProduct,
			productsAndAvailableOffers: categoryWithProduct.productsAndAvailableOffers?.map(product =>
				updateProductWishlistStatus(product, productId, isInWishlist)
			),
		};
	};
	
	const handleWishlistChange = (productId: string, isInWishlist: boolean) => {
		setProductsByCategories(prevProductsByCategories =>
			prevProductsByCategories.map(categoryWithProduct =>
				updateCategoryProducts(categoryWithProduct, productId, isInWishlist)
			)
		);
	};

	const categories = categoriesData?.categories ?? [];
    const isLoading = isCategoriesLoading || isProductsLoading;

	return (
		<>
			<StoreTabSelector />
			<div className={styles.storeContainer}>
				<div className={styles.innerContainer}>
					<div className={styles.topFlexDiv}>
						{/* <SignInOrRegister /> */}
						<StoreBanner />
					</div>
					{isLoading ? (
						<BounceLoader size={200} color="#DE841B" />
					) : (
						<>
							<ShopByLayout hideButtons label="">
								<NewDeals />
							</ShopByLayout>
							<ShopByLayout hideButtons label="Shop by Categories">
								{categories.map((x) => (
									<CategoryItem key={x.id} category={x} />
								))}
							</ShopByLayout>
							{productsByCategories.map((x) => (
								<ShopByLayout key={x.category?.id} label={`Shop by ${x.category.name}`} navigateUrl={`/store/category/${x.category.name}`}>
									{x.productsAndAvailableOffers?.map((item, i) => (
										<ProductItem key={`${i}-item`} solarProduct={item} onWishlistChange={handleWishlistChange} />
									))}
								</ShopByLayout>
							))}
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default StoreFront;
